import { bool, func, string } from 'prop-types';
import React, { forwardRef } from 'react';
import { FaImage } from 'react-icons/fa';
import protectCopyRight from '../helpers/protectCopyRight';

const WIDTH_SMALL = 200;
const WIDTH_MEDIUM_SMALL = 300;
const WIDTH_MEDIUM = 400;
const WIDTH_MEDIUM_LARGE = 500;
const WIDTH_LARGE = 600;
const WIDTH_X_LARGE = 700;
const WIDTH_XX_LARGE = 800;

const widthsRegex = /_\d{3}x$/;
const widths = [
    WIDTH_SMALL,
    WIDTH_MEDIUM_SMALL,
    WIDTH_MEDIUM,
    WIDTH_MEDIUM_LARGE,
    WIDTH_LARGE,
    WIDTH_X_LARGE,
    WIDTH_XX_LARGE
];
const cdnDomain = new URL(process.env.RESOURCE_ATTACHMENTS_URL).hostname;

const ResponsiveImage = forwardRef(({
    imageUrl,
    imageAlt,
    className,
    placeholderClassName,
    mobileSize,
    desktopSize,
    onClick,
    lazyLoad,
}, ref) => {
    if (typeof imageUrl !== 'string'
        || !imageUrl.length) {
        return (<FaImage
            className={placeholderClassName ?? className}
        />);
    }
    const srcSet = [];
    if (imageUrl.lastIndexOf('.') !== -1
        && imageUrl.includes(cdnDomain)
        && widthsRegex.exec(imageUrl) === null
        && process.env.RESPONSIVE_IMAGES === 'true') {
        const extensionIdx = imageUrl.lastIndexOf('.');
        for (const width of widths) {
            const widthImageUrl =
                imageUrl.slice(0, extensionIdx)
                + `_${width}x`
                + imageUrl.slice(extensionIdx);
            srcSet.push(`${widthImageUrl} ${width}w`);
        }
    }

    return (<img
        onContextMenu={protectCopyRight}
        ref={ref}
        className={className}
        alt={imageAlt ?? ''}
        {...onClick && { 
            onClick,
            tabIndex: 0,
            role: 'button',
            onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(e);
                }
            }
        }}
        {...(!srcSet.length) ? ({
            src: imageUrl,
        }) : ({
            sizes: '(max-width: 768px) ' + mobileSize + ',\n'
                + desktopSize,
            srcSet: srcSet.join(', '),
            'data-sizes': 'auto',
            'data-widths': JSON.stringify(widths),
            'data-srcset': srcSet.join(', '),
        })}
        {...lazyLoad === true && ({
            loading: 'lazy',
        })}
    />);
});

ResponsiveImage.propTypes = {
    imageUrl: string,
    imageAlt: string,
    className: string,
    placeholderClassName: string,
    mobileSize: string,
    desktopSize: string,
    onClick: func,
    lazyLoad: bool,
};

ResponsiveImage.defaultProps = {
    imageUrl: '',
    imageAlt: '',
    className: '',
    placeholderClassName: '',
    mobileSize: '200px',
    desktopSize: '200px',
    onClick: () => {},
    lazyLoad: true,
};

ResponsiveImage.displayName = 'ResponsiveImage';

export default ResponsiveImage;